export default "__VITE_ASSET__DpaIHJ9$__"